import React from "react";
import { ActivityIndicator, Modal, View } from "react-native";
import { styles } from "./styles";

export default ({ loading = false, opacity = 0.4 }) => {
  return (
    <Modal
      transparent
      animationType={"none"}
      visible={loading}
      onRequestClose={() => null}
    >
      <View
        style={[
          styles.modalBackground,
          { backgroundColor: `rgba(0,0,0,${opacity})` },
        ]}
      >
        <View style={styles.activityIndicatorWrapper}>
          <ActivityIndicator
            animating={loading}
            color="#D71D9A"
            size="small"
          />
        </View>
      </View>
    </Modal>
  );
};
